module.exports = __webpack_public_path__ + "static/img/logo240.ba757d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo240.png
// module id = FwlX
// module chunks = 1